import { ClickhouseDataset } from '../enums/enum.js';
// TODO consider `as const satisfies DatasetDetails` over variable typing for deep inference
export const datasetDetails = {
    // schema in Click House
    [ClickhouseDataset.crewClaimLineItems]: {
        // schema display name
        displayName: 'Returns & Warranties',
        sampleQuestions: [
            'What is the most common requested resolution method?',
            'What is my most returned product this month?',
            'Show me all my claim reasons, ordered with the most common reason first.',
        ],
        columns: [
            {
                name: 'quantity',
                displayName: 'Quantity',
                description: 'The quantity being claimed. If 4 were ordered and the claim applies to 2 of them, this value will be 2',
            },
            {
                name: 'requested_resolution_method',
                displayName: 'Requested Resolution Method',
                description: 'The resolution method requested by the customer when opening the claim',
            },
            {
                name: 'created_on',
                displayName: 'Created On',
                description: 'When the claim was opened',
            },
            {
                name: 'updated_on',
                displayName: 'Updated On',
                description: 'The date and time of when the claim line item was updated',
            },
            {
                name: 'resolution_method',
                displayName: 'Resolution Method',
                description: 'How the claim line item was eventually finalized',
            },
            {
                name: 'amount',
                displayName: 'Amount',
                description: 'Sum of all costs on the line item',
            },
            {
                name: 'requested_amount',
                displayName: 'Requested Amount',
                description: 'The cost of the claim as originally requested by the customer',
            },
            {
                name: 'restocked_quantity',
                displayName: 'Restocked Quantity',
                description: 'Quantity of product that was restocked',
            },
            {
                name: 'claim_line_items_count',
                displayName: 'Claim Line Items Count',
                description: 'The resolution method requested by the customer when opening the claim',
            },
            {
                name: 'crew_claim_reason',
                displayName: 'Claim Reason',
                description: 'The reason for the claim',
            },
            {
                name: 'crew_claim_reason_category',
                displayName: 'Claim Reason Category',
                description: 'The category of the claim',
            },
            {
                name: 'store_product_variant_title',
                displayName: 'Product Variant Title',
                description: 'Title (or name) for the product variant being claimed',
            },
            {
                name: 'store_product_title',
                displayName: 'Product Title',
                description: 'Title (or name) for the product being claimed',
            },
            {
                name: 'crew_claim_status',
                displayName: 'Claim Status',
                description: 'current ',
            },
            {
                name: 'crew_claim_status_detail',
                displayName: 'Claim Status Detail',
                description: 'Detail associated with the claim status',
            },
            {
                name: 'original_order_line_item_price',
                displayName: 'Original Order Line Item Price',
                description: 'Cost of the original line item being claimed against',
            },
            {
                name: 'original_order_line_item_sku',
                displayName: 'Original Order Line Item SKU',
                description: 'SKU of the original line item being claimed against',
            },
            {
                name: 'original_order_number',
                displayName: 'Original Order Number',
                description: 'Order number of the original line item being claimed against',
            },
            {
                name: 'original_order_city',
                displayName: 'Original Order City',
                description: 'Shipping city of the original line item being claimed against',
            },
            {
                name: 'original_order_state',
                displayName: 'Original Order State',
                description: 'Shipping state of the original line item being claimed against',
            },
            {
                name: 'original_order_postal_code',
                displayName: 'Original Order Postal Code',
                description: 'Shipping postal code of the original line item being claimed against',
            },
            {
                name: 'return_shipment_type',
                displayName: 'Return Shipment Type',
                description: 'How the return shipment will be handled',
            },
            {
                name: 'crew_claim_reason_detail',
                displayName: 'Claim Reason Detail',
                description: 'Detail around the reason for the claim',
            },
            {
                name: 'claim_type',
                displayName: 'Claim Type',
                description: 'Type of the claim (Return, Warranty, etc.)',
            },
            {
                name: 'is_instant_variant_exchange',
                displayName: 'Is An Instant Variant Exchange',
                description: 'A true/false representation of wether the claim was handled as an instant variant exchange',
            },
            {
                name: 'claim_rollup_status',
                displayName: 'Claim Rollup Status',
                description: 'The status of the top-level claim, representing a roll up of the individual claim line items under it',
            },
        ],
    },
    [ClickhouseDataset.shipProtectClaims]: {
        displayName: 'Shipping Claims',
        columns: [
            {
                name: 'claim_status',
                displayName: 'Claim Status',
                description: 'The current status of the claim',
            },
            {
                name: 'status_last_changed_date',
                displayName: 'Date of Last Status Change',
                description: 'The date and time the status of the claim last changed',
            },
            {
                name: 'claim_reason',
                displayName: 'Claim Reason',
                description: 'The reason for the claim',
            },
            {
                name: 'note_from_customer',
                displayName: 'Note From Customer',
                description: 'Any note placed by the customer while filing a claim',
            },
            {
                name: 'resolution_method',
                displayName: 'Resolution Method',
                description: 'How the claim was resolved (refund, reorder, etc.)',
            },
            {
                name: 'resolution_date',
                displayName: 'Resolution Date',
                description: 'The date and time when the order was marked as resolved',
            },
            {
                name: 'invoice_date',
                displayName: 'Invoice Date',
                description: 'The date when the claim was calculated as part of an invoice',
            },
            {
                name: 'claim_source',
                displayName: 'Claim Source',
                description: 'How the claim was entered',
            },
            {
                name: 'refund_total_amount',
                displayName: 'Refund Total Amount',
                description: 'Total amount refunded',
            },
            {
                name: 'earliest_refund_date',
                displayName: 'Earliest Refund Date',
                description: 'Earliest refund date (if there were multiple refunds)',
            },
            {
                name: 'latest_refund_date',
                displayName: 'Latest Refund Date',
                description: 'Latest refund date (if there were multiple refunds)',
            },
            {
                name: 'refund_amount_paid_by_corso',
                displayName: 'Refund Amount Paid by Corso',
                description: 'Any refund amount paid by Corso directly',
            },
            {
                name: 'refund_count',
                displayName: 'Refund Count',
                description: 'Total number of refunds issued',
            },
            {
                name: 'reorder_amount_paid_by_corso',
                displayName: 'Reorder Amount Paid By Corso',
                description: 'Any reorder amount paid by Corso directly',
            },
            {
                name: 'earliest_reorder_date',
                displayName: 'Earliest Reorder Date',
                description: 'Earliest reorder date (if there were multiple reorders)',
            },
            {
                name: 'latest_reorder_date',
                displayName: 'Latest Reorder Date',
                description: 'Latest reorder date (if there were multiple reorders)',
            },
            {
                name: 'reorder_count',
                displayName: 'Reorder Count',
                description: 'Total number of reorders issued',
            },
            {
                name: 'original_order_total',
                displayName: 'Original Order Total',
                description: 'Total value of the original order being claimed against',
            },
            {
                name: 'original_order_date',
                displayName: 'Original Order Date',
                description: 'Date and time of the original order being claimed against',
            },
            {
                name: 'reorder_total_amount',
                displayName: 'Reorder Total Amount',
                description: 'Total amount of reorders issued',
            },
        ],
        sampleQuestions: [
            'Which carrier has had the most total claims?',
            "What's the most common claim reason?",
            'What is the order number for my single most expensive reorder, and how much was it?',
        ],
    },
    [ClickhouseDataset.storeOrders]: {
        displayName: 'Orders',
        sampleQuestions: [
            'Which month had the most orders so far this year?',
            'Which state has the most orders?',
            'Which month and year has the most orders of all time, and what is the total of these orders?',
        ],
        columns: [
            {
                name: 'order_canceled_date',
                displayName: 'Order Canceled Date',
                description: 'Date the order was canceled',
            },
            {
                name: 'order_canceled_reason',
                displayName: 'Order Canceled Reason',
                description: 'Reason the order was canceled',
            },
            {
                name: 'order_date_from_platform',
                displayName: 'Order Date',
                description: 'Date and time the order was placed',
            },
            {
                name: 'order_subtotal',
                displayName: 'Order Subtotal',
                description: 'Subtotal amount of the order, before shipping, taxes, etc.',
            },
            {
                name: 'order_total',
                displayName: 'Order Total',
                description: 'Total cost of the order',
            },
            {
                name: 'order_number_from_platform',
                displayName: 'Platform Order Number',
                description: 'Date the order was canceled',
            },
            {
                name: 'sales_channel',
                displayName: 'Sales Channel',
            },
            {
                name: 'shipping_address_city',
                displayName: 'Shipping Address City',
                description: 'Shipping Address City',
            },
            {
                name: 'shipping_address_state',
                displayName: 'Shipping Address State',
                description: 'Shipping Address State',
            },
            {
                name: 'shipping_address_zip',
                displayName: 'Shipping Address Zip',
                description: 'Shipping Address Zip/Postal Code',
            },
            {
                name: 'shipping_address_country_code',
                displayName: 'Shipping Address Country',
                description: 'Shipping Address Country',
            },
            {
                name: 'carbon_grams',
                displayName: 'Carbon Grams',
                description: 'Estimated amount of carbon associated with order shipping, in grams',
            },
            {
                name: 'is_gsp_attached',
                displayName: 'Is GSP Attached',
                description: 'Wether Shipping Protection was attached on the order',
            },
            {
                name: 'claim_count',
                displayName: 'Claim Count',
                description: 'NUmber of claims associated with the order',
            },
            {
                name: 'sum_claimed_line_item_price',
                displayName: 'Claimed Line Item Price',
                description: 'Total cost of all claims against the order',
            },
        ],
    },
    [ClickhouseDataset.storeProductVariants]: {
        displayName: 'Products & Variants',
        sampleQuestions: ['What is my most expensive product?'],
        columns: [
            {
                name: 'product_title',
                displayName: 'Product Title',
                description: 'Product title',
            },
            {
                name: 'title',
                displayName: 'Title',
                description: 'Variant Title',
            },
            {
                name: 'sku',
                displayName: 'SKU',
                description: 'Variant SKU',
            },
            {
                name: 'is_deleted_on_platform',
                displayName: 'Is Deleted',
                description: 'True/False indicator for wether the variant has been deleted in Shopify',
            },
            {
                name: 'created_on',
                displayName: 'Created On',
                description: 'The date and time when the variant was created',
            },
            {
                name: 'updated_on',
                displayName: 'Updated On',
                description: 'The date and time when the variant was updated',
            },
            {
                name: 'price',
                displayName: 'Price',
                description: 'Price of the variant',
            },
            {
                name: 'grams',
                displayName: 'Grams',
                description: 'Weight of the variant, in grams',
            },
            {
                name: 'claim_count',
                displayName: 'Claim Count',
                description: 'Count of all claims against the variant',
            },
        ],
    },
};
//# sourceMappingURL=datasetDetails.js.map